import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import SeparatedList from 'components/shared/SeparatedList'
import TicketRow from './TicketRow'
import CabanaItem from 'components/shared/Reservation/ticketRows/CabanaItem'
import Link from 'components/shared/Link'
import { FormattedMessage } from 'react-intl'
import { useApp } from 'store/steps'
import NewCabanas from 'components/shared/Reservation/ticketRows/NewCabanas'
import { ReservationRowProps } from 'components/shared/Reservation/types'
import { CabanaReservation } from 'store/selfcare-slice/types'

interface CabanaRowProps extends ReservationRowProps {
    cabanas: CabanaReservation[] | null
}

const CabanaRow = ({
    mode,
    handleEdit,
    cabanas,
    isDownloadingAttachementsDisabled = false,
}: CabanaRowProps) => {
    const { stepId, language } = useApp()
    const isSummary = stepId === 'summary'

    return (
        <Box isFullWidth>
            <Box
                direction="row"
                align="center"
                justify="space-between"
                isFullWidth
                mb={[16, 24]}
            >
                <Text variant="heading3" color="secondary_700">
                    <FormattedMessage
                        id="selfcare.cabana.section_caption"
                        defaultMessage="Cabana"
                    />
                </Text>
                {mode === 'reservation' && !isDownloadingAttachementsDisabled && (
                    <Link
                        variant="primary"
                        textVariant="bodySmallStrong"
                        icon={null}
                        path={`${process.env.REACT_APP_API_URL}api/${language}/selfcare/attachment/cabana`}
                        data-testid="selfcare-button-download-cabana"
                    >
                        <FormattedMessage
                            id="selfcare.download_tickets"
                            defaultMessage="Pobierz bilety"
                        />
                    </Link>
                )}
                {mode === 'summary' && handleEdit && (
                    <Link
                        variant="gray"
                        icon={null}
                        onClick={() => handleEdit('manage-cabanas')}
                        data-testid="selfcare-summary-button-edit-cabanas"
                    >
                        <FormattedMessage
                            id="selfcare.edit"
                            defaultMessage="Edytuj"
                        />
                    </Link>
                )}
            </Box>
            <Box isFullWidth>
                <SeparatedList
                    direction="column"
                    gap={[16, 24]}
                    isFullWidth
                    borderWidth={2}
                    borderColor="grayscale_300"
                    hasLastItemBorder
                >
                    {cabanas?.map((cabana) => {
                        const { changes, original, changeType } = cabana

                        const dataToDisplay =
                            isSummary && changes ? changes : original
                        const { price, detail } = dataToDisplay || {}
                        const { orderCabanaId } = detail || {}

                        const cabanaPrice = price || 0
                        const isReturned = isSummary && changeType === 'return'

                        return (
                            <TicketRow
                                price={cabanaPrice}
                                key={orderCabanaId}
                                isReturned={isReturned}
                            >
                                <CabanaItem
                                    cabana={cabana}
                                    isDisabled={isReturned}
                                />
                            </TicketRow>
                        )
                    })}

                    <NewCabanas />
                </SeparatedList>
            </Box>
        </Box>
    )
}

export default CabanaRow
